export const SETTING_ZTL = {
  SET_CURRENT_STEP: 'SET_CURRENT_STEP',
  SETTING_ONBOARDING: 'SETTING_ONBOARDING',
  SET_SUPPORTED_BANKS: 'SET_SUPPORTED_BANKS'
};